export default class AnimationManager {
    constructor() {
        this.registry = {};
        this.instances = {};
    }

    register( key, instance ) {
        if( this.registry.hasOwnProperty( key ) ) return;

        this.registry[key] = instance;
    }

    get( key ) {
        if( this.instances.hasOwnProperty( key ) ) return this.instances[key].clear();

        this.instances[key] = new this.registry[key];
        return this.instances[key];
    }
}